import React from 'react';

import Select2 from 'components/Pages/Admin/Itinerary/shared/Select2';
import Preview from 'components/Pages/Admin/shared/Preview';
import { IOptions } from 'components/shared/FormAdapters/FormDefault/InlineSelect/types';
import Visibility from 'components/shared/Icon/icons/Visibility';
import Modal from 'components/shared/Modal';
import { useEscAction } from 'hooks/useEscAction';

import sceneClassNames from '../index.module.css';
import { useContentBlockDropdown, useScenePositioning } from './functions';
import { IContentBlockDropdownProps } from './types';

function ContentBlockDropdown({ anchorRef, onAdd, onClose }: IContentBlockDropdownProps) {
  useEscAction(onClose);
  const { sceneRef, sceneStyles, menuPlacement } = useScenePositioning(anchorRef || { current: null });
  const { isPreviewModalOpen, modalData, selectRef, loadOptions, openModal, closeModal, handleSelectPage } =
    useContentBlockDropdown({ onAdd, onClose });

  return (
    <div className={sceneClassNames.sceneWrapper} style={sceneStyles}>
      {/*@ts-ignore*/}
      <div style={{ position: 'relative' }}>
        <div ref={sceneRef}>
          {/*@ts-ignore*/}
          <Select2
            placeholder="Search Content Library"
            loadOptions={loadOptions}
            selectRef={selectRef}
            onChange={handleSelectPage}
            onOptionActionClick={(data: IOptions) => openModal(data.value as string)}
            optionActionIcon={Visibility}
            blockMenuClosing={isPreviewModalOpen}
            renderNoOptionsMessage={() => {
              return 'No pages found';
            }}
            menuPlacement={menuPlacement}
            maxMenuHeight={200}
            size="mini"
          />
        </div>
        {isPreviewModalOpen && (
          // @ts-ignore
          <Modal noPortal noPadding size="lg" isOpen={isPreviewModalOpen} toClose={closeModal}>
            {isPreviewModalOpen && <Preview pageId={modalData.pageId} />}
          </Modal>
        )}
      </div>
    </div>
  );
}

export default ContentBlockDropdown;
